<template>
  <div class="lab-evaluation-container">

    <!-- Loader -->
    <div v-if="fetchData" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
    </div>

    <!-- INTERNAL EXAM TABLE -->
    <div v-if="labContinuousLabs.length && !fetchData" class="mt-3">

      <b-card class="mt-4">



        <!-- TOP ACTION ROW -->
        <div class="d-flex justify-content-between align-items-center mb-3">

          <!-- LEFT : ADD -->
          <b-button variant="info" size="sm" @click="$bvModal.show('internalParamModal')">
            Add / Remove Internal Exam Parameters
          </b-button>

          <!-- RIGHT : SAVE -->
          <b-button variant="success" size="sm" @click="updateLabEvaluationOptions(activeLabId)">
            Save
          </b-button>

        </div>

        <!-- PARAMETERS TABLE -->
        <table v-if="enabledLabHeaders.length" class="table table-bordered table-striped mt-2">
          <thead>
            <tr>
              <th>No.</th>
              <th>Header</th>
              <th>Max. Score</th>
            </tr>
          </thead>
          <tbody>
            <!-- FIRST 2 -->
            <tr v-for="header in visibleHeaders" :key="header.name">
              <td><b-form-input v-model.number="header.no" type="number" min="1" placeholder="Sl. No" /></td>
              <td>{{ header.name }}</td>
              <td><b-form-input v-model.number="header.score" type="number" min="0" placeholder="Max. score" /></td>
            </tr>

            <!-- REMAINING -->
            <template v-if="showAllHeaders">
              <tr v-for="header in remainingHeaders" :key="header.name">
                <td><b-form-input v-model.number="header.no" type="number" min="1" placeholder="Sl. No" /></td>
                <td>{{ header.name }}</td>
                <td><b-form-input v-model.number="header.score" type="number" min="0" placeholder="Max. score" /></td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- EMPTY STATE -->
        <div v-else class="text-center text-muted py-4">
          No parameters added yet
        </div>

        <!-- SHOW MORE / LESS -->
        <div v-if="enabledLabHeaders.length > 2" class="text-center mt-2">
          <b-link @click="showAllHeaders = !showAllHeaders">
            {{ showAllHeaders ? "Show less" : "Show more" }}
          </b-link>
        </div>

      </b-card>
    </div>

    <!-- PARAMETER MODAL -->
    <b-modal id="internalParamModal" size="xl" title="Add / Remove Internal Exam Parameters" centered hide-footer>
      <b-form-checkbox-group v-model="selectedParams">
        <b-row>
          <b-col cols="6" md="4" lg="3" v-for="param in labParamList" :key="param.key" class="mb-2">
            <b-form-checkbox :value="param.key">
              {{ param.name }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>


      <div class="text-right mt-3">
        <b-button variant="success" @click="saveParameters">Proceed</b-button>
        <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('internalParamModal')">Cancel</b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "InternalExamEvaluationParameter",
  props: ["course_id"],

  data() {
    return {
      courseLabs: [],
      selectedParams: [],
      activeLabId: null,
      showAllHeaders: false,
      fetchData: false,

      labEvaluationOptions: {
        internal_exam: {
          Practical: { id: "", enable: false, score: "", no: "", name: "Practical" },
          Record: { id: "", enable: false, score: "", no: "", name: "Record" },
          Algorithm: { id: "", enable: false, score: "", no: "", name: "Algorithm" },
          Program: { id: "", enable: false, score: "", no: "", name: "Program" },
          Output: { id: "", enable: false, score: "", no: "", name: "Output" },
          Viva: { id: "", enable: false, score: "", no: "", name: "Viva" },

          LabWork: { id: "", enable: false, score: "", no: "", name: "LabWork" },
          ObservationAndResult: { id: "", enable: false, score: "", no: "", name: "ObservationAndResult" },
          AimAndProcedure: { id: "", enable: false, score: "", no: "", name: "AimAndProcedure" },
          OpenEndedExperiment: { id: "", enable: false, score: "", no: "", name: "OpenEndedExperiment" },

          CourseProject: { id: "", enable: false, score: "", no: "", name: "CourseProject" },
          PreliminaryWork: { id: "", enable: false, score: "", no: "", name: "PreliminaryWork" },
          ImplementingTheWork: { id: "", enable: false, score: "", no: "", name: "ImplementingTheWork" },
          Performance: { id: "", enable: false, score: "", no: "", name: "Performance" },
          WrittenExam: { id: "", enable: false, score: "", no: "", name: "WrittenExam" },

          Knowledge: { id: "", enable: false, score: "", no: "", name: "Knowledge" },
          Experiment: { id: "", enable: false, score: "", no: "", name: "Experiment" },
          Documentation: { id: "", enable: false, score: "", no: "", name: "Documentation" },
          SafetyAndCleanup: { id: "", enable: false, score: "", no: "", name: "SafetyAndCleanup" },
          ToolsAndEquipment: { id: "", enable: false, score: "", no: "", name: "ToolsAndEquipment" },
          Procedure: { id: "", enable: false, score: "", no: "", name: "Procedure" },
          DataAndResult: { id: "", enable: false, score: "", no: "", name: "DataAndResult" },
          LabRecordAndGithub: { id: "", enable: false, score: "", no: "", name: "LabRecordAndGithub" },
          TimelyCompletionOfTask: { id: "", enable: false, score: "", no: "", name: "TimelyCompletionOfTask" },
          ClassViva: { id: "", enable: false, score: "", no: "", name: "ClassViva" },
          Exam: { id: "", enable: false, score: "", no: "", name: "Exam" },
          PresentationAndPreLabWork: { id: "", enable: false, score: "", no: "", name: "PresentationAndPreLabWork" },
          ConductOfExperiment: { id: "", enable: false, score: "", no: "", name: "ConductOfExperiment" },
          LabReportAndRecordKeeping: { id: "", enable: false, score: "", no: "", name: "LabReportAndRecordKeeping" },
          PreparationAndPreLabWork: { id: "", enable: false, score: "", no: "", name: "PreparationAndPreLabWork" },
        },
      },
    };
  },

  computed: {
    labContinuousLabs() {
      return this.courseLabs.filter(l => l.type === "internal_exam");
    },
    enabledLabHeaders() {
      return Object.values(this.labEvaluationOptions.internal_exam).filter(h => h.enable);
    },
    visibleHeaders() {
      return this.enabledLabHeaders.slice(0, 2);
    },
    remainingHeaders() {
      return this.enabledLabHeaders.slice(2);
    },
    labParamList() {
      return Object.entries(this.labEvaluationOptions.internal_exam).map(([key, val]) => ({ key, ...val }));
    },
  },

  async created() {
    try {
      this.fetchData = true;

      // Load labs
      await this.getCourseLabs();

      // Create lab if not exists
      if (!this.labContinuousLabs.length) {
        await this.createLabForCourse();
        await this.getCourseLabs();
      }

      // Get continuous evaluation lab
      const internal =
        this.labContinuousLabs.find(lab => lab.type === 'internal_exam');

      // Proceed only if lab exists
      if (internal) {
        this.activeLabId = internal.id;
        await this.getLabEvaluationOptions();
      }

    } catch (error) {
      console.error("Error in created hook:", error);
    } finally {
      this.fetchData = false;
    }
  },

  methods: {
    async getCourseLabs() {
      const res = await axios.get(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities?course=${this.course_id}`
      );
      this.courseLabs = res.data;
    },

    async createLabForCourse() {
      await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities`,
        { course_id: this.course_id, type: "internal_exam" }
      );
    },

    async getLabEvaluationOptions() {
      const res = await axios.get(
        `${this.$store.getters.getAPIKey.mainAPI}/labevaluationheaders?course=${this.course_id}`
      );

      Object.values(this.labEvaluationOptions.internal_exam).forEach(h => (h.enable = false));
      this.selectedParams = [];

      res.data.forEach(header => {
        if (header.lab_activity_id !== this.activeLabId) return;

        const option = this.labEvaluationOptions.internal_exam[header.name];
        if (!option) return;

        option.id = header.id;
        option.score = header.maximum_mark;
        option.no = header.no;
        option.enable = true;

        this.selectedParams.push(header.name);
      });
    },

    saveParameters() {
      Object.entries(this.labEvaluationOptions.internal_exam).forEach(([key, val]) => {
        val.enable = this.selectedParams.includes(key);
      });
      this.showAllHeaders = false;
      this.$bvModal.hide("internalParamModal");
    },

    async updateLabEvaluationOptions() {
      const payload = [];

      for (const h of this.enabledLabHeaders) {
        if (!h.score || !h.no) {
          this.$toast.error("Please fill SI.No and Max Score for all enabled parameters");
          return;
        }
        payload.push({
          name: h.name,
          maximum_mark: Number(h.score),
          no: h.no,
          lab_activity_id: this.activeLabId,
        });
      }

      await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labevaluationheaders`,
        { labHeaders: payload, lab_activity_id: this.activeLabId }
      );

      this.$toast.success("Internal exam parameters updated successfully");
    },
  },
};
</script>
